import { Link } from 'react-router-dom';
import { maskDecimal } from '@givebutter/util';
import { faGift } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';
import { PledgeActions } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/pledge/PledgeActions';
import { EmptyData } from 'components/util';
import { CurrencySymbol } from 'customHooks/useCurrencySymbol';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { isoDateFromServer } from 'helpers/dates';
import { Contact, PledgeOffScheduleActivity } from 'types/domain';

interface PledgeOffScheduleProps {
    item: PledgeOffScheduleActivity;
    contact: Contact | null;
}

const PledgeOffSchedule = ({ item, contact }: PledgeOffScheduleProps) => {
    const { accountId } = useCurrentAccount();

    return (
        <ActivityItem.Root>
            <ActivityItem.Trigger>
                <ActivityItem.Icon className="bg-orange-50">
                    <FontAwesomeIcon className="text-orange-500" icon={faGift} />
                </ActivityItem.Icon>
                <p className="text-left">
                    <span className="font-medium">
                        {contact?.first_name} {contact?.last_name}'s
                    </span>{' '}
                    <Link to={`/accounts/${accountId}/pledges/${item.resource.pledge.id}/edit`}>
                        <CurrencySymbol />
                        {maskDecimal(item.resource.pledge.amount)} pledge
                    </Link>{' '}
                    is off-schedule
                </p>
                <PledgeActions pledge={item.resource.pledge} contact={contact} />
            </ActivityItem.Trigger>
            <ActivityItem.Content>
                <div className="flex flex-col justify-between gap-4 md:flex-row">
                    <div>
                        <p className="text-sm text-gray-600">Payment needed</p>
                        <p className="font-medium text-black">
                            <CurrencySymbol />
                            {maskDecimal(item.resource.payment_needed)}
                        </p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-600">Balance</p>
                        <p className="font-medium text-black">
                            <CurrencySymbol />
                            {maskDecimal(item.resource.pledge_balance)}
                        </p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-600">Missed installment date</p>
                        <p className="font-medium text-black">
                            {item.resource.missed_installment_date ? (
                                isoDateFromServer(item.resource.missed_installment_date).toFormat(
                                    'dd MMM, yyyy',
                                )
                            ) : (
                                <EmptyData />
                            )}
                        </p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-600">Installments left</p>
                        <p className="font-medium text-black">{item.resource.installments_left}</p>
                    </div>
                </div>
            </ActivityItem.Content>
        </ActivityItem.Root>
    );
};

export { PledgeOffSchedule };
